<div class="mh">
  <div><h2>我的工单</h2></div>
  <button class="close" mat-dialog-close>×</button>
</div>
<div class="mb" mat-dialog-content>
  <div class="ticket-tabs">
    <button class="tt" [ngClass]="{ active: index === 1 }" (click)="index = 1">
      处理中
    </button>
    <button class="tt" [ngClass]="{ active: index === 2 }" (click)="index = 2">
      已完成
    </button>
  </div>
  <div class="ticket-list" *ngIf="index === 1">
    <button
      *ngFor="let item of data.open"
      type="button"
      class="tc"
      (click)="checkFormDetail(item.id)"
    >
      <div style="flex: 1; min-width: 0">
        <div class="tc-top">
          <div>
            <h3>{{ item.ticket_no }} · {{ item.problem_item.name }}</h3>
            <p>
              {{ item.platform?.name }} ·
              {{ item.bus_seat.bus.bus_account?.username }}
            </p>
          </div>
          <span class="pill" [ngClass]="item.status">{{
            status(item.status)
          }}</span>
        </div>
        <div
          class="tc-eta offhours"
          *ngIf="item.status === 'waiting_confirmation'"
        >
          <span>处理进度</span><b>客服已回复，待您确认解决情况</b>
        </div>
        <div
          class="tc-eta offhours"
          *ngIf="item.status !== 'waiting_confirmation'"
        >
          <span>预计处理时间</span>
          <b>{{ item.problem_item.ticket_estimated_minutes }}</b>
        </div>
      </div>
      <div
        style="
          margin-left: 14px;
          color: #cbd5e1;
          font-size: 24px;
          line-height: 1;
          display: flex;
          align-items: center;
        "
      >
        ›
      </div>
    </button>
  </div>
  <div class="ticket-list" *ngIf="index === 2">
    <button
      *ngFor="let item of data.done"
      type="button"
      class="tc"
      (click)="checkFormDetail(item.id)"
    >
      <div style="flex: 1; min-width: 0">
        <div class="tc-top">
          <div>
            <h3>{{ item.ticket_no }} · {{ item.problem_item.name }}</h3>
            <p>
              {{ item.platform?.name }} ·
              {{ item.bus_seat.bus.bus_account?.username }}
            </p>
          </div>
          <span class="pill" [ngClass]="item.status">{{
            status(item.status)
          }}</span>
        </div>
        <div class="tc-eta offhours">
          <span>预计处理时间</span>
          <b>{{ item.problem_item.ticket_estimated_minutes }}</b>
        </div>
      </div>
      <div
        style="
          margin-left: 14px;
          color: #cbd5e1;
          font-size: 24px;
          line-height: 1;
          display: flex;
          align-items: center;
        "
      >
        ›
      </div>
    </button>
  </div>
</div>
